import { Link } from "react-router-dom";
import { ArrowUpRight, ShieldCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import EyeMark from "@/components/EyeMark";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-[#060606]">
            <div className="grid md:grid-cols-2 border-t border-white/10">
                <Reveal className="p-10 sm:p-14 border-b md:border-b-0 md:border-r border-white/10">
                    <p className="font-mono-accent text-xs tracking-[0.28em] uppercase text-[#D8BC7A]">
                        For Clients
                    </p>
                    <h3 className="font-display text-2xl sm:text-3xl font-bold text-[#F6F4EF] mt-4 leading-snug">
                        Looking to hire or grow your pipeline? Partner with us.
                    </h3>
                    <p className="text-[#A6A69C] mt-3 text-sm leading-relaxed max-w-md">
                        Brief us on a mandate, order CV formatting or a lead batch, or
                        explore a research retainer. Reply within 4 business hours.
                    </p>
                    <Link
                        to="/contact"
                        data-testid="dual-cta-client-partner-btn"
                        className="mt-7 inline-flex items-center gap-2 bg-[#C9A24B] hover:bg-[#D8BC7A] text-[#0C0C0C] font-semibold px-6 py-3 text-sm transition-colors duration-200 active:scale-[0.98]"
                    >
                        Partner With Us <ArrowUpRight size={16} />
                    </Link>
                </Reveal>
                <Reveal delay={0.1} className="p-10 sm:p-14 bg-[#171717]">
                    <p className="font-mono-accent text-xs tracking-[0.28em] uppercase text-[#D8BC7A]">
                        For Candidates
                    </p>
                    <h3 className="font-display text-2xl sm:text-3xl text-[#F6F4EF] mt-4 leading-snug">
                        Register your interest in our talent pool.
                    </h3>
                    <p className="text-[#A6A69C] mt-3 text-sm leading-relaxed max-w-md">
                        Join a curated, confidential talent pool and be considered for
                        senior mandates before they reach the open market.
                    </p>
                    <Link
                        to="/contact"
                        data-testid="dual-cta-candidate-register-btn"
                        className="mt-7 inline-flex items-center gap-2 border border-[#C9A24B]/60 text-[#E7E4DC] hover:bg-[#C9A24B]/10 font-semibold px-6 py-3 text-sm transition-colors duration-200 active:scale-[0.98]"
                    >
                        Register Interest <ArrowUpRight size={16} />
                    </Link>
                </Reveal>
            </div>

            <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-4 border-t border-white/10">
                <div className="md:col-span-2">
                    <div className="flex items-center gap-3">
                        <EyeMark size={38} />
                        <span className="font-display font-semibold text-[#F6F4EF]">
                            Vantage Crest Research
                        </span>
                    </div>
                    <p className="text-[#A6A69C] text-sm mt-4 max-w-sm leading-relaxed">
                        Talent Intelligence, Delivered. Research-led recruitment support
                        for every industry, every hiring need.
                    </p>
                    <p className="font-mono-accent text-[10px] tracking-[0.2em] text-[#77776E] mt-6 uppercase">
                        LAT 18.9220 N · LON 72.8346 E · Mumbai, India
                    </p>
                </div>
                <div>
                    <p className="font-mono-accent text-xs tracking-[0.22em] uppercase text-[#D8BC7A] mb-4">
                        Sitemap
                    </p>
                    <ul className="space-y-2.5 text-sm text-[#A6A69C]">
                        {[
                            ["Home", "/"],
                            ["About", "/about"],
                            ["Services", "/services"],
                            ["Industries", "/industries"],
                            ["Contact", "/contact"],
                        ].map(([label, to]) => (
                            <li key={to}>
                                <Link to={to} className="hover:text-[#E7E4DC] transition-colors">
                                    {label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div>
                    <p className="font-mono-accent text-xs tracking-[0.22em] uppercase text-[#D8BC7A] mb-4">
                        Contact
                    </p>
                    <ul className="space-y-2.5 text-sm text-[#A6A69C]">
                        <li>Bandra-Kurla Complex (BKC)</li>
                        <li>Mumbai, Maharashtra 400051</li>
                        <li>inquiries@vantagecrestresearch.com</li>
                        <li>+91 22 4978 3100</li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                    <p className="text-xs text-[#77776E]">
                        © {new Date().getFullYear()} Vantage Crest Research. All rights reserved.
                    </p>
                    <p className="flex items-center gap-2 text-xs text-[#77776E]">
                        <ShieldCheck size={14} className="text-[#C9A24B]" />
                        Strict data protection & confidentiality protocols on every engagement
                    </p>
                </div>
            </div>
        </footer>
    );
}
